import React, { useEffect } from 'react';
import I18n from '@/modules/i18n';
import Text from '@/components/ui/Text';
import { LinkButton } from '@/components/ui/Buttons';
import useSlideFrames from '@/hooks/api/useSlideFrames';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import { ISlide } from '@/components/admin/SlideShow/stores/useSlideShowStore';
import FrameTile from './FrameTile';
import ScoutButton from './ScoutButton';
import useApplyFrame from './useApplyFrame';

interface FramePickerProps {
  slide: ISlide;
  onRemoveFrame: () => void;
}

const FramePicker = ({ slide, onRemoveFrame }: FramePickerProps) => {
  const { data: frames } = useSlideFrames();
  const isSysAdmin = useSlideShowContext(state => state.isSysAdmin);
  const setPreviewFrame = useSlideShowContext(state => state.setPreviewFrame);
  const { applyFrame } = useApplyFrame(slide);

  useEffect(() => () => setPreviewFrame(null), []);

  return (
    <div className="tw-p-4">
      <Text size="sm" tag="h2" variant="label">{I18n.t('select_a_pattern')}</Text>
      <div className="tw-mt-3 tw-grid tw-grid-cols-4 tw-gap-2">
        {frames.map(frame => (
          <FrameTile
            key={frame.id}
            frame={frame}
            selected={slide.slideFrameId === frame.id}
            onPreview={setPreviewFrame}
            onSelect={applyFrame}
          />
        ))}
      </div>
      {isSysAdmin && <ScoutButton slide={slide} />}
      {!!slide.slideFrameId && (
        <>
          <hr className="tw-mt-3 tw-border-tci-gray-300" />
          <LinkButton className="tw-mt-3 tw-block tw-p-0" color="red" onClick={onRemoveFrame}>
            {I18n.t('remove_frame')}
          </LinkButton>
        </>
      )}
    </div>
  );
};

export default FramePicker;
